import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "64",
  height: "53.396",
  viewBox: "0 0 64 53.396"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("feOffset", { input: "SourceAlpha" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("feGaussianBlur", {
  stdDeviation: "3",
  result: "blur"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("feFlood", { "flood-color": "#635733" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("feComposite", {
  operator: "in",
  in2: "blur"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("feComposite", { in: "SourceGraphic" }, null, -1)
const _hoisted_8 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  id: "组件_7_4",
  "data-name": "组件 7 – 4",
  transform: "translate(10 2.5)"
}
const _hoisted_10 = ["filter"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  id: "联合_1-2",
  "data-name": "联合 1",
  d: "M-1186.037,106.565H-1198.5a2,2,0,0,1-2-2V80.5a2,2,0,0,1,2-2h40a2,2,0,0,1,2,2v24.065a2,2,0,0,1-2,2h-17.85l-4.844,4.907Z",
  transform: "translate(1210.5 -68.5)",
  fill: "#4b422e",
  stroke: "#dcc47e",
  "stroke-width": "2"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("text", {
  id: "飞台",
  transform: "translate(21.5 27)",
  fill: "#ddc28c",
  "font-size": "16",
  "font-family": "PingFangSC-Regular, PingFang SC"
}, [
  /*#__PURE__*/_createElementVNode("tspan", {
    x: "-16",
    y: "0"
  }, "飞台")
], -1)
const _hoisted_14 = {
  key: 0,
  id: "椭圆_276",
  "data-name": "椭圆 276",
  transform: "translate(34.5)",
  fill: "#f10a02",
  stroke: "#fff",
  "stroke-width": "2"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "9",
  cy: "9",
  r: "9",
  stroke: "none"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "9",
  cy: "9",
  r: "8",
  fill: "none"
}, null, -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      _createElementVNode("filter", {
        id: _ctx.filterId,
        x: "0",
        y: "0",
        width: "64",
        height: "53.396",
        filterUnits: "userSpaceOnUse"
      }, _hoisted_8, 8, _hoisted_2)
    ]),
    _createElementVNode("g", _hoisted_9, [
      _createElementVNode("g", {
        transform: "matrix(1, 0, 0, 1, -10, -2.5)",
        filter: `url(#${_ctx.filterId})`
      }, _hoisted_12, 8, _hoisted_10),
      _hoisted_13,
      (_ctx.count > 0)
        ? (_openBlock(), _createElementBlock("g", _hoisted_14, _hoisted_17))
        : _createCommentVNode("", true)
    ])
  ]))
}